export type PaperSize = "A4" | "A3" | "Legal" | "Letter";
export type CollageTemplateType = "grid1x1" |"grid1x2" | "grid2x1" | "grid2x2" | "grid3x1" | "grid3x2" | "grid3x3" | "auto";

export const PAPER_SIZES: Record<PaperSize, { width: number; height: number }> = {
  A4: { width: 210, height: 297 },
  A3: { width: 297, height: 420 },
  Legal: { width: 216, height: 356 },
  Letter: { width: 216, height: 279 },
};
